export const iconFontAwesomeChartsDiagramsSquarePollVertical = (
	<i className="fa-solid fa-square-poll-vertical"></i>
);
